import { mapKeys } from 'lodash'
import { shallowRef } from 'vue'
import { defineLocalStore } from '@/utils/localStore'
import axios from '@/plugins/axios'
import { urlProtocolRelated, urlProtocolTreeRelated } from '@/utils/urls'
import { handleAsync } from 'best-modules/plugins'

export const {
  useLocalStore: useRelatedProtocols,
  initLocalStore: initRelatedProtocols,
} = defineLocalStore('relatedProtocols', (protocolId: number) => {
  const relatedProtocols = shallowRef<any[]>([])
  const parentProtocols = shallowRef<any[]>([])
  const childrenProtocols = shallowRef<any[]>([])

  const prepareProtocols = (protocols: any, childrenKey: any) => {
    return protocols?.map((o: any) => {
      o = mapKeys(o, (value, key) => {
        if (key === childrenKey) {
          return 'children'
        } else {
          return key
        }
      })
      if (o.children.length) {
        o.children = prepareProtocols(o.children, childrenKey)
      }

      return o
    })
  }

  const getTreeRelatedProtocols = () => {
    return handleAsync('relatedProtocols', () => {
      return axios.get(urlProtocolTreeRelated(protocolId)).then(res => {
        parentProtocols.value = prepareProtocols(
          res.data.treeParentRelatedProtocols,
          'treeParentRelatedProtocols'
        )

        childrenProtocols.value = prepareProtocols(
          res.data.treeChildrenRelatedProtocols,
          'treeChildrenRelatedProtocols'
        )
      })
    })
  }
  const getRelatedProtocols = () => {
    return handleAsync('relatedProtocols', () => {
      return axios.get(urlProtocolRelated(protocolId)).then(res => {
        relatedProtocols.value = res.data
      })
    })
  }

  getRelatedProtocols()
  getTreeRelatedProtocols()

  return {
    parentProtocols,
    childrenProtocols,
    relatedProtocols,
    getRelatedProtocols,
    getTreeRelatedProtocols,
  }
})
